<template>
    <div class="layout-topbar">
        <router-link to="/" class="layout-topbar-logo">
            <img :src="topbarImage()" class="logofull" />
            <img :src="topbarImageMin()" class="logomin" />
        </router-link>

        <div class="layout-topbar-title">
            <!--
        <span class="font-medium text-3xl text-100">Difusión de Información</span>
        -->
        </div>

        <div></div>

        <button class="p-button layout-topbar-menu-button" @click="showMenu" v-show="mostrarBotonMenu()">
            <i class="pi pi-bars"></i>
        </button>


    </div>
</template>

<script>
export default {
  data() {
    return {

			currentUser: "",
			usrSig: "US",
			isLoggedIn: false,

    };
  },
  methods: {
    onMenuToggle(event) {
      this.$emit("menu-toggle", event);
    },
    onTopbarMenuToggle(event) {
      this.$emit("topbar-menu-toggle", event);
    },
    topbarImage() {
      return "./images/logo_sie.png";
    },
    topbarImageMin() {
      return "./images/logo_sie_mini.png";
    },
    toggleUsr(event) {
      this.$refs.op.toggle(event);
    },
    centroAplicaciones() {
      this.$router.push({path: '/hub'});
    },
    mostrarBotonMenu(){
      return this.$route.name != 'inicio';
    },    
    showMenu() {
      this.$nextTick(() => {
        if (!document.querySelector('#menu').classList.value.includes('layout-menu-enable')){
          document.querySelector('#menu').classList.add('layout-menu-enable');
        }else{
          document.querySelector('#menu').classList.remove('layout-menu-enable');
        }        
        //console.log(document.querySelector('#menu').classList);        
      })
    },
		getUsrSig(nombre, apellidoP){
			this.usrSig = nombre.charAt(0) + apellidoP.charAt(0);
		},    
  },
  mounted() {
    /*
		this.$oidc.getUser().then(user => {
			if (user) {
				this.currentUser = user.profile.FirstName.split(" ")[0] + " " + user.profile.MiddleName;
				this.isLoggedIn = user !== null && !user.expired;

				this.getUsrSig(user.profile.FirstName, user.profile.MiddleName);
			}
		}).catch(error => {console.log(error)});
    */
  },
};
</script>

<style scoped>
  .btn-home{
    position: fixed;
    right: 5.5rem;
    background-color: transparent;
    border: 0;
  }

  .btn-home span{
    padding-left: 6px;
    font-weight: initial;
  }

</style>